import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../../../../store/context/simple-context";
import { getTrueClasses } from "../../../../../../../helpers";
import "./index.scss";

const Checkbox = ({ optionName }) => {
  const {
    data: { optionsState },
    translate: { t },
    update: { updateOptionsState },
  } = useContext(SimpleContext);
  const status = optionsState[optionName];
  return (
    <div
      className={getTrueClasses(
        "GP-C-O-O-P-C",
        status && "GP-C-O-O-P-C_active"
      )}
      onClick={() => updateOptionsState({ [optionName]: !status })}
    >
      <div className="GP-C-O-O-P-C__statusText">
        {t(status ? "Added" : "Add")}
      </div>
    </div>
  );
};

Checkbox.propTypes = {
  optionName: PropTypes.string.isRequired,
};

export default Checkbox;
